import React, { useState, useEffect } from 'react';
import { isAuthenticated, adminLogin } from '../../services/apiService';

const T = { white: '#FFFFFF', bg: '#F4F2EE', border: '#E0DDD6', text: '#1C1A17',
  muted: '#7A7772', brand: '#3E4954', green: '#166534', greenBg: '#DCFCE7',
  red: '#9F1239', redBg: '#FFE4E6', amber: '#92400E', amberBg: '#FEF3C7', borderSm: '#ECEAE4' };

function Check({ status, label }) {
  const cfg = {
    'ok':            { bg: T.greenBg, color: T.green,  icon: '✓', text: 'Vorhanden' },
    'no_id':         { bg: T.amberBg, color: T.amber,  icon: '⚠', text: 'Keine ID gespeichert' },
    'not_found':     { bg: T.redBg,   color: T.red,    icon: '✗', text: 'FEHLT (404)' },
    'error_403':     { bg: '#F0F9FF', color: '#0369A1', icon: '?', text: 'Kein Zugriff (403)' },
    'error_401':     { bg: '#F0F9FF', color: '#0369A1', icon: '?', text: 'Nicht autorisiert' },
    'network_error': { bg: T.amberBg, color: T.amber,  icon: '?', text: 'Netzwerkfehler' },
  }[status] || { bg: T.amberBg, color: T.amber, icon: '?', text: status || '—' };
  return (
    <span style={{ display:'inline-flex', alignItems:'center', gap:4, fontSize:11,
      background: cfg.bg, color: cfg.color, padding:'1px 7px', borderRadius:4, fontWeight:600 }}>
      {cfg.icon} {cfg.text}
    </span>
  );
}

function RepairBtn({ booking_ref, target, label, onRepaired, loading, setLoading }) {
  const repair = async () => {
    setLoading(booking_ref + target);
    try {
      const res = await fetch(`/api/admin/calendar-repair/${booking_ref}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${sessionStorage.getItem('zba_admin_token')}` },
        body: JSON.stringify({ target }),
      });
      const d = await res.json();
      if (d.success) onRepaired();
      else alert('Fehler: ' + d.error);
    } catch (e) { alert(e.message); }
    finally { setLoading(null); }
  };
  const isLoading = loading === booking_ref + target;
  return (
    <button onClick={repair} disabled={!!loading} style={{
      padding:'3px 10px', fontSize:11, fontWeight:600, borderRadius:5, cursor:'pointer',
      background: T.brand, color:'white', border:'none', opacity: loading ? 0.6 : 1,
    }}>
      {isLoading ? '⟳' : '↻'} {label}
    </button>
  );
}

export default function CalendarDebug() {
  const [auth, setAuth] = useState(isAuthenticated());
  const [pw, setPw] = useState('');
  const [pwErr, setPwErr] = useState('');
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [repairLoading, setRepairLoading] = useState(null);
  const [filter, setFilter] = useState('all'); // 'all' | 'problems'
  const [updated, setUpdated] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await fetch('/api/admin/calendar-debug', {
        headers: { Authorization: `Bearer ${sessionStorage.getItem('zba_admin_token')}` }
      });
      const d = await r.json();
      setBookings(d.bookings || []);
      setUpdated(new Date().toLocaleTimeString('de-DE'));
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { if (auth) load(); }, [auth]);

  const handleLogin = async e => {
    e.preventDefault();
    const r = await adminLogin(pw);
    if (r.success) { setAuth(true); setPwErr(''); }
    else setPwErr('Falsches Passwort');
  };

  if (!auth) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:T.bg, fontFamily:'system-ui' }}>
      <div style={{ background:T.white, border:`1px solid ${T.border}`, borderRadius:14, padding:36, width:300 }}>
        <div style={{ fontWeight:700, fontSize:18, marginBottom:20 }}>Kalender-Debug</div>
        <form onSubmit={handleLogin}>
          <input type="password" value={pw} onChange={e=>setPw(e.target.value)} placeholder="Passwort" autoFocus
            style={{ width:'100%', padding:'9px 12px', border:`1px solid ${T.border}`, borderRadius:7, fontSize:13,
              marginBottom:10, boxSizing:'border-box', fontFamily:'system-ui', outline:'none' }} />
          {pwErr && <div style={{ color:T.red, fontSize:12, marginBottom:10 }}>{pwErr}</div>}
          <button type="submit" style={{ width:'100%', padding:10, background:T.brand, color:'white',
            border:'none', borderRadius:7, fontSize:14, fontWeight:700, cursor:'pointer' }}>Einloggen</button>
        </form>
      </div>
    </div>
  );

  const shown = filter === 'problems' ? bookings.filter(b => b.needsRepair) : bookings;
  const problems = bookings.filter(b => b.needsRepair).length;

  return (
    <div style={{ minHeight:'100vh', background:T.bg, fontFamily:'system-ui' }}>
      {/* Header */}
      <div style={{ background:T.white, borderBottom:`1px solid ${T.border}`, height:48,
        display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 24px',
        position:'sticky', top:0, zIndex:20 }}>
        <div style={{ display:'flex', alignItems:'center', gap:14 }}>
          <img src="https://zba.academy/webinar/images/zbalogo2.png" style={{ height:20 }} alt="ZBA" />
          <span style={{ width:1, height:18, background:T.borderSm, display:'block' }} />
          <span style={{ fontSize:13, fontWeight:700 }}>Kalender-Sync Debug</span>
          {problems > 0 && (
            <span style={{ background:T.redBg, color:T.red, fontSize:11, fontWeight:700,
              padding:'2px 8px', borderRadius:100 }}>
              {problems} Problem{problems !== 1 ? 'e' : ''}
            </span>
          )}
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          {updated && <span style={{ fontSize:11, color:T.muted }}>Stand: {updated}</span>}
          <button onClick={load} disabled={loading}
            style={{ height:32, padding:'0 14px', borderRadius:7, border:`1px solid ${T.border}`,
              background:T.brand, color:'white', fontSize:12, fontWeight:600, cursor:'pointer' }}>
            {loading ? '⟳ Prüfe…' : '↻ Alles prüfen'}
          </button>
          <select value={filter} onChange={e=>setFilter(e.target.value)}
            style={{ height:32, padding:'0 10px', border:`1px solid ${T.border}`, borderRadius:7,
              fontSize:12, background:T.white, fontFamily:'system-ui' }}>
            <option value="problems">Nur Probleme ({problems})</option>
            <option value="all">Alle ({bookings.length})</option>
          </select>
          <a href="/admin/bookings" style={{ height:32, padding:'0 12px', borderRadius:7,
            border:`1px solid ${T.border}`, background:T.white, fontSize:12, color:T.muted,
            display:'inline-flex', alignItems:'center', textDecoration:'none' }}>← Buchungen</a>
        </div>
      </div>

      <div style={{ maxWidth:1400, margin:'0 auto', padding:24 }}>
        {loading && !bookings.length ? (
          <div style={{ textAlign:'center', padding:100, color:T.muted }}>
            <div style={{ fontSize:28, marginBottom:8 }}>⟳</div>
            Prüfe alle Kalendereinträge via Microsoft Graph…<br/>
            <small>Kann 20–60 Sek. dauern</small>
          </div>
        ) : shown.length === 0 ? (
          <div style={{ textAlign:'center', padding:80, background:T.white, borderRadius:14,
            border:`1px solid ${T.border}`, color:T.muted }}>
            <div style={{ fontSize:32, marginBottom:10 }}>✓</div>
            <div style={{ fontWeight:700, fontSize:16, color:T.text, marginBottom:4 }}>Alles synchron!</div>
            Alle {bookings.length} Buchungen haben korrekte Kalendereinträge.
          </div>
        ) : (
          <div style={{ background:T.white, borderRadius:14, border:`1px solid ${T.border}`, overflow:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ borderBottom:`2px solid ${T.border}` }}>
                  {['Datum', 'Ref', 'Name', 'Berater', 'Typ', 'Berater-Kalender', 'ZBA-Kalender', 'Aktion'].map(h => (
                    <th key={h} style={{ padding:'10px 14px', textAlign:'left', fontSize:10,
                      fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', color:T.muted,
                      whiteSpace:'nowrap', background:'#FAFAF8' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {shown.map(b => (
                  <tr key={b.booking_ref} style={{
                    borderBottom:`1px solid ${T.borderSm}`,
                    background: b.needsRepair ? (b.personalOk && !b.zbaOk ? '#FFFBEB' : '#FFF5F5') : 'white',
                  }}>
                    <td style={{ padding:'10px 14px', whiteSpace:'nowrap' }}>
                      <div style={{ fontSize:12, fontWeight:600 }}>{b.date}</div>
                      <div style={{ fontSize:11, color:T.muted }}>{b.time}</div>
                    </td>
                    <td style={{ padding:'10px 14px', fontSize:10, color:T.muted, fontFamily:'monospace' }}>
                      {b.booking_ref}
                    </td>
                    <td style={{ padding:'10px 14px' }}>
                      <div style={{ fontSize:13, fontWeight:600 }}>{b.vorname} {b.nachname}</div>
                      <div style={{ fontSize:11, color:T.muted }}>{b.email}</div>
                    </td>
                    <td style={{ padding:'10px 14px', fontSize:12, color:T.muted }}>
                      {(b.berater_name || '').split(' ').map(p=>p[0]).join('') || b.berater_email}
                    </td>
                    <td style={{ padding:'10px 14px' }}>
                      <span style={{ fontSize:11, padding:'2px 7px', borderRadius:4,
                        background: b.type === 'onsite' ? '#DBEAFE' : '#F0FDF4',
                        color: b.type === 'onsite' ? '#1E40AF' : '#166534', fontWeight:600 }}>
                        {b.type === 'onsite' ? '🏢 Vor-Ort' : '📞 Telefon'}
                      </span>
                    </td>
                    <td style={{ padding:'10px 14px' }}>
                      <Check status={b.personalStatus} label="Berater" />
                    </td>
                    <td style={{ padding:'10px 14px' }}>
                      <Check status={b.zbaStatus} label="ZBA-Kalender" />
                    </td>
                    <td style={{ padding:'10px 14px' }}>
                      <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                        <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
                          {["not_found","no_id"].includes(b.personalStatus) && (
                            <RepairBtn booking_ref={b.booking_ref} target="personal"
                              label="Berater-Kal." onRepaired={load}
                              loading={repairLoading} setLoading={setRepairLoading} />
                          )}
                          {/* ZBA repair always visible — 403 errors hide real missing events */}
                          <RepairBtn booking_ref={b.booking_ref} target="zba"
                            label={["not_found","no_id"].includes(b.zbaStatus) ? "↻ ZBA-Kal." : "⟳ ZBA neu"}
                            onRepaired={load}
                            loading={repairLoading} setLoading={setRepairLoading} />
                          {["not_found","no_id"].includes(b.personalStatus) && (
                            <RepairBtn booking_ref={b.booking_ref} target="both"
                              label="Beide neu" onRepaired={load}
                              loading={repairLoading} setLoading={setRepairLoading} />
                          )}
                        </div>
                        <div style={{ fontSize:9, color:'#94A3B8', fontFamily:'monospace', lineHeight:1.6 }}>
                          <div title={b.outlook_event_id || 'keine'}>
                            Ber: {b.outlook_event_id ? b.outlook_event_id.substring(0,18)+'…' : <span style={{color:'#F59E0B'}}>keine ID</span>}
                          </div>
                          <div title={b.verwaltung_event_id || 'keine'}>
                            ZBA: {b.verwaltung_event_id ? b.verwaltung_event_id.substring(0,18)+'…' : <span style={{color:'#F59E0B'}}>keine ID</span>}
                          </div>
                        </div>
                        {b.adminActions?.length > 0 && (
                          <div style={{ marginTop:4, padding:'4px 6px', background:'#FEE2E2',
                            borderRadius:4, fontSize:10, color:'#991B1B', lineHeight:1.5 }}>
                            {b.adminActions.map((a, i) => (
                              <div key={i}>🗑 Via App gelöscht · {a.performed_by || 'unbekannt'} · {a.performed_at?.substring(0,16)?.replace('T',' ')}</div>
                            ))}
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
